import { useState } from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

import tableInfo2023 from '../program/table/prevTableInfo2023.json';
import tableInfo2024 from '../program/table/prevTableInfo2024.json';
import tableInfo2025 from '../program/table/prevTableInfo2025.json';
import { TableProgram } from '../program/table/tableProgram';
import './previous.scss';
import Footer from '../footer/footer';

export default function Previous() {
  const { t } = useTranslation();
  const [selectedYear, setSelectedYear] = useState('');

  // Función para manejar el clic en los botones de año
  const handleYearClick = (year: string) => {
    setSelectedYear(year);
  };

  return (
    <Box className="previousContainer">
      <ButtonGroup variant="outlined" className="yearButtonGroup">
        <Button
          className={`yearButton ${selectedYear === '2023' ? 'active' : ''}`}
          onClick={() => handleYearClick('2023')}
        >
          2023
        </Button>
        <Button
          className={`yearButton ${selectedYear === '2024' ? 'active' : ''}`}
          onClick={() => handleYearClick('2024')}
        >
          2024
        </Button>
        <Button
          className={`yearButton ${selectedYear === '2025' ? 'active' : ''}`}
          onClick={() => handleYearClick('2025')}
        >
          2025
        </Button>
      </ButtonGroup>
      {selectedYear === '2023' && (
        <TableProgram tableInfo={tableInfo2023}></TableProgram>
      )}
      {selectedYear === '2024' && (
        <TableProgram tableInfo={tableInfo2024}></TableProgram>
      )}
      {selectedYear === '2025' && (
        <TableProgram tableInfo={tableInfo2025}></TableProgram>
      )}
      <Footer />
    </Box>
  );
}
